import AdobeHogar from "../providers/adobeHogar";
import Facebook from "../providers/facebook";
import Google from "../providers/google";
import * as MUTATIONS from "../../config/constants/mutation-types";

const pixelDb = {
  triggers: {
    [MUTATIONS.ON_ROUTE]: {
      paso1: ["AdobeHogar.paso1", "Facebook.paso1", "Google.paso1"],
      paso2: ["AdobeHogar.paso2", "Facebook.paso2", "Google.paso2"],
      paso3: ["AdobeHogar.paso3", "Facebook.paso3", "Google.paso3"],
      paso4: ["AdobeHogar.paso4", "Facebook.paso4", "Google.paso4"],
      loading: ["AdobeHogar.verificacion"],
      mensaje: ["AdobeHogar.errorPage"]
    },
    [MUTATIONS.ADOBE_INTERNAL_LINK]: ["AdobeHogar.internalLink"],
    [MUTATIONS.ADOBE_APP_STARTED]: ["AdobeHogar.appStarted"],
    [MUTATIONS.ADOBE_APP_ON_CLICK_START]: ["AdobeHogar.appOnClickStart"],
    [MUTATIONS.ADOBE_MODAL]: ["AdobeHogar.modal"]
  },
  providers: {
    AdobeHogar,
    Facebook,
    Google
  }
};

export default pixelDb;
